let allIconValues = []

function getAllIcons () {
  // avoid transformation of document.styleSheets if we already have the icon values
  if (allIconValues.length) return allIconValues

  allIconValues = Object.values(document.styleSheets)
    .flatMap(style => Object.values(style.cssRules))
    .filter(rule => rule?.selectorText?.startsWith('.icon-') && rule?.selectorText?.indexOf(',') === -1 && rule?.selectorText?.endsWith('::before'))
    .map(rule => rule.selectorText.replace('::before', '').replace('.icon-', ''))
  return allIconValues
}

export const allIcons = getAllIcons
